var productZoomSlider = null;
const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    productMedia: document.querySelector('[data-productMedia]'),
    zoomBtns: document.querySelectorAll('[data-productZoom]'),


    cartCheckout: document.querySelector('.product-form'),
    checkoutSticky: document.querySelector('.pdp-qty-btns'),
    body: document.querySelector('body'),
    stickyAtcBar: document.querySelector('[data-sticky-atc-bar]')
};

const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
window.productMedia = mediaJSON;
class TemplateProductJS {
    constructor() {
        // Custom code for product page goes here
        this.stickyCheckout();
        this.initStickyAtcBar();

        // Initialize HTML cache for product switching
        this.productCache = {};

        // Initialize variant data collection
        this.variantData = {};
        this.collectVariantData();

        selectors.zoomBtns.forEach((btn) => {
            btn.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                let currentTarget = event.target;
                this.manageZoom(currentTarget);
            })
        });

        // Initialize product option switching
        this.initProductOptionSwitching();
    }

    // Collect all variant data from data-item-variants scripts
    collectVariantData() {
        const variantScripts = document.querySelectorAll('script[data-item-variants]');
        
        variantScripts.forEach(script => {
            try {
                const variantData = JSON.parse(script.textContent.trim());
                const parentElement = script.closest('[data-item-handle]');
                
                if (parentElement && variantData.length > 0) {
                    const productHandle = parentElement.getAttribute('data-item-handle');
                    this.variantData[productHandle] = variantData;
                }
            } catch (error) {
                console.error('Error parsing variant data:', error);
            }
        });
    }

    // Get selected variant ID based on current form selections
    getSelectedVariantId(productHandle) {
        if (!this.variantData[productHandle]) {
            return null;
        }

        // Get all selected options from the current product form
        const selectedOptions = {};
        
        // Look for selected radio buttons, select elements, etc.
        const formInputs = this.productForm.querySelectorAll('[data-optionindex="1"] input:checked');
        
        formInputs.forEach(input => {
            if (input.name && input.value) {
                selectedOptions[input.name] = input.value;
            }
        });

        // Find matching variant based on selected options
        const variants = this.variantData[productHandle];
        const matchingVariant = variants.find(variant => {
            // Check if this variant matches the selected options
            return variant.option1 && selectedOptions[Object.keys(selectedOptions)[0]] === variant.option1;
        });
        
        return matchingVariant ? matchingVariant.id : null;
    }

    // Initialize event listeners for product option switching
    initProductOptionSwitching() {
        document.addEventListener('click', (event) => {
            const itemHandleElement = event.target.closest('[data-item-handle]');
            if (itemHandleElement) {
                event.preventDefault();
                event.stopImmediatePropagation();
                this.productForm = event.target.closest('product-form');
                this.handleProductSwitch(itemHandleElement);
            }
        });
    }

    // Handle product switching when clicking on data-item-handle elements
    async handleProductSwitch(element) {
        const productHandle = element.getAttribute('data-item-handle');
        
        if (!productHandle) {
            return;
        }

        // Get selected variant ID if available
        const variantId = this.getSelectedVariantId(productHandle);
        const cacheKey = variantId ? `${productHandle}-${variantId}` : productHandle;

        try {
            // Check if we have cached HTML for this product+variant combination
            if (this.productCache[cacheKey]) {
                this.replaceMainContent(this.productCache[cacheKey], productHandle, variantId);
                return;
            }

            // Construct the product URL with variant if available
            let productUrl = `/products/${productHandle}`;
            var urlParams = new URLSearchParams();
            if (variantId) {
                urlParams.set('variant', variantId);
            }
            
            if(window.location.search.includes('purchase_type=onetime')){
              urlParams.set('purchase_type', 'onetime');
            }
            // Fetch the new product content
            const response = await fetch(productUrl);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const html = await response.text();
            const parser = new DOMParser();
            const newDocument = parser.parseFromString(html, 'text/html');
            
            // Extract the new MainContent
            const newMainContent = newDocument.querySelector('#MainContent');
            
            if (newMainContent) {
                // Cache the HTML content with variant-specific key
                this.productCache[cacheKey] = newMainContent?.innerHTML;
                
                // Replace the content
                this.replaceMainContent(newMainContent?.innerHTML, productHandle, variantId);
            }
            
        } catch (error) {
            console.error('Error switching product:', error);
            // Fallback to regular navigation
            let fallbackUrl = `/products/${productHandle}`;
            if (variantId) {
                fallbackUrl += `?variant=${variantId}`;
            }
            window.location.href = fallbackUrl;
        }
    }

    // Replace MainContent and handle URL update
    replaceMainContent(htmlContent, productHandle, variantId = null) {
        const currentMainContent = document.querySelector('#MainContent');
        const currentScrollX = window.scrollX || window.pageXOffset || 0;
        const currentScrollY = window.scrollY || window.pageYOffset || 0;
        const restoreScrollPosition = () => {
            window.scrollTo({
                left: currentScrollX,
                top: currentScrollY,
                behavior: 'auto'
            });
        };
        
        if (currentMainContent && currentMainContent.innerHTML) {
            // Store Yotpo widget HTML before replacement
            const yotpoWidget = currentMainContent.querySelector('[data-yotpo-instance-id="762356"]');
            const storedYotpoHTML = yotpoWidget ? yotpoWidget.outerHTML : null;
            // Replace the entire MainContent
            currentMainContent.innerHTML = htmlContent;
            restoreScrollPosition();
            
            // Restore the stored Yotpo widget if it existed
            if (storedYotpoHTML) {
                const newYotpoContainer = currentMainContent.querySelector('[data-yotpo-instance-id="762356"]');
                if (newYotpoContainer) {
                    newYotpoContainer.outerHTML = storedYotpoHTML;
                }
            }
            
            // Update the browser URL without page reload
            let productUrl = `/products/${productHandle}`;
            const urlParams = new URLSearchParams();
            
            if (variantId) {
                urlParams.set('variant', variantId);
            }
            
            // Preserve purchase_type parameter if it exists
            const currentParams = new URLSearchParams(window.location.search);
            const purchaseType = currentParams.get('purchase_type');
            if (purchaseType) {
                urlParams.set('purchase_type', purchaseType);
            }
            
            // Add query parameters to URL if any exist
            if (urlParams.toString()) {
                productUrl += `?${urlParams.toString()}`;
            }
            
            window.history.pushState({}, '', productUrl);
            
            // Reinitialize components and events
            this.reinitializeAfterSwitch();
            restoreScrollPosition();
            requestAnimationFrame(restoreScrollPosition);
            setTimeout(restoreScrollPosition, 100);
        }
    }

    // Reinitialize components and events after DOM replacement
    reinitializeAfterSwitch() {
        // Update selectors with new elements
        selectors.productContainer = document.querySelector('.product-details-wrapper');
        selectors.productMedia = document.querySelector('[data-productMedia]');
        selectors.zoomBtns = document.querySelectorAll('[data-productZoom]');
        selectors.cartCheckout = document.querySelector('.product-form');
        selectors.checkoutSticky = document.querySelector('.pdp-qty-btns');
        selectors.stickyAtcBar = document.querySelector('[data-sticky-atc-bar]');

        // Recollect variant data from new content
        this.collectVariantData();

        // Reinitialize product media if it exists
        const newProductMedia = document.querySelector('[data-productMedia]');
        if (newProductMedia) {
            try {
                const newMediaJSON = JSON.parse(newProductMedia?.innerHTML);
                window.productMedia = newMediaJSON;
            } catch (error) {
                console.error('Error parsing new product media:', error);
            }
        }

        // Reattach zoom button events
        selectors.zoomBtns.forEach((btn) => {
            btn.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                let currentTarget = event.target;
                this.manageZoom(currentTarget);
            });
        });

        // Reinitialize sticky checkout
        this.stickyCheckout();
        this.initStickyAtcBar();

        // Dispatch custom events for other scripts
        const productSwitchedEvent = new CustomEvent('productSwitched', {
            detail: {
                timestamp: Date.now(),
                url: window.location.href
            }
        });
        document.dispatchEvent(productSwitchedEvent);

        // Trigger reinit event for other components
        const reinitEvent = new CustomEvent('productReinit');
        document.dispatchEvent(reinitEvent);

        // Reinitialize Yotpo widgets
        if (typeof yotpoWidgetsContainer !== 'undefined' && yotpoWidgetsContainer.initWidgets) {
            yotpoWidgetsContainer.initWidgets();
        }

        document.querySelectorAll('img[data-src]').forEach(img => {
            img.setAttribute('src', img.getAttribute('data-src'));
        });
        document.querySelectorAll('img[data-srcset]').forEach(img => {
            img.setAttribute('srcset', img.getAttribute('data-srcset'));
        });
    }

    // Sticky checkout container on oage scroll
    stickyCheckout() {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const checkoutStickyBoxRect = selectors.checkoutSticky?.getBoundingClientRect();
                
                if (entry.isIntersecting || checkoutStickyBoxRect.top > 0) {
                    selectors.checkoutSticky.classList.remove('m-st-active');
                    selectors.body.classList.remove('active');
                    if (selectors.stickyAtcBar) selectors.stickyAtcBar.hidden = true;
                } else {
                    selectors.checkoutSticky.classList.add('active');
                    selectors.body.classList.add('m-st-active');
                    if (selectors.stickyAtcBar) selectors.stickyAtcBar.hidden = false;
                }
            });
        });
        observer.observe(selectors.cartCheckout);
    }

    initStickyAtcBar() {
        const bar = selectors.stickyAtcBar;
        if (!bar) return;

        const btn = bar.querySelector('[data-sticky-atc-btn]');
        if (btn && !btn.dataset.bound) {
            btn.dataset.bound = 'true';
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                const realBtn =
                    document.querySelector('.template-product-section .effect-product-options .pdp-btn .submit_btn') ||
                    document.querySelector('.template-product-section .pdp-btn .submit_btn');
                realBtn?.click();
            });
        }

        const syncAll = () => {
            this.syncStickyAtcPrice();
            this.syncStickyAtcVariant();
            this.syncStickyAtcDisabled();
        };

        syncAll();

        if (!bar.dataset.variantListener) {
            bar.dataset.variantListener = 'true';
            document.addEventListener('variant:changed', () => syncAll());
        }

        if (!bar.__priceObserver) {
            const priceEl = document.querySelector('.template-product-section .price-wrapper.d-flex.m-price');
            if (priceEl) {
                bar.__priceObserver = new MutationObserver(() => this.syncStickyAtcPrice());
                bar.__priceObserver.observe(priceEl, {
                    childList: true,
                    subtree: true,
                    characterData: true,
                    attributes: true
                });
            }
        }
    }

    syncStickyAtcPrice() {
        const bar = selectors.stickyAtcBar;
        if (!bar) return;

        const productForm =
            document.querySelector('.template-product-section product-form') ||
            document.querySelector('product-form');

        if (productForm?.updateStickyPriceForQuantity) {
            const qtyInput = productForm.querySelector('[data-qty-input]');
            const quantity = parseInt(qtyInput?.value, 10);
            productForm.updateStickyPriceForQuantity(
                Number.isFinite(quantity) && quantity > 0 ? quantity : 1
            );
            return;
        }

        const target = bar.querySelector('[data-sticky-atc-btn-price]');
        if (!target) return;

        const priceWrapper = document.querySelector('.template-product-section .price-wrapper.d-flex.m-price');
        if (!priceWrapper) return;

        const tmp = document.createElement('div');
        tmp.innerHTML = priceWrapper.innerHTML;

        // remove any discount/badge UI from the sticky bar
        tmp.querySelectorAll('.badge,[data-subscription-discount-badge],[data-subscription_percentage]').forEach((el) => el.remove());

        target.innerHTML = tmp.innerHTML;
    }

    syncStickyAtcVariant() {
        const bar = selectors.stickyAtcBar;
        if (!bar) return;

        const currentVariant = window.globalVariables?.product?.currentVariant;
        if (!currentVariant) return;

        const img = bar.querySelector('[data-sticky-atc-image]');
        const src = currentVariant?.featured_image?.src || currentVariant?.featured_media?.preview_image?.src;
        if (img && src) {
            img.setAttribute('src', src);
            img.setAttribute('srcset', src);
            if (currentVariant?.name) img.setAttribute('alt', currentVariant.name);
        }

        const variantEl = bar.querySelector('[data-sticky-atc-variant]');
        if (variantEl) {
            variantEl.textContent = currentVariant?.title || '';
        }
    }

    syncStickyAtcDisabled() {
        const bar = selectors.stickyAtcBar;
        if (!bar) return;

        const btn = bar.querySelector('[data-sticky-atc-btn]');
        if (!btn) return;

        // Prefer variant availability (source of truth) to avoid getting stuck
        // if the real submit button is temporarily disabled during init/hydration.
        const currentVariant = window.globalVariables?.product?.currentVariant;
        if (currentVariant && typeof currentVariant.available === 'boolean') {
            const isDisabled = !currentVariant.available;
            btn.disabled = isDisabled;
            btn.classList.toggle('disabled', isDisabled);
            return;
        }

        const realBtn =
            document.querySelector('.template-product-section .effect-product-options .pdp-btn .submit_btn') ||
            document.querySelector('.template-product-section .pdp-btn .submit_btn');
        if (!realBtn) {
            btn.disabled = false;
            btn.classList.remove('disabled');
            return;
        }

        // Mirror the real button's actual disabled state (attribute/property),
        // not a CSS class that might be used for styling.
        const isDisabled = !!(realBtn.disabled || realBtn.hasAttribute('disabled'));

        btn.disabled = isDisabled;
        btn.classList.toggle('disabled', isDisabled);
    }

    manageZoom(currentTarget) {
        let currentSlide = currentTarget.closest('.product--media');
        let currentSlideIndex = 1;
        if (currentSlide) currentSlideIndex = Array.from(currentSlide.parentNode.children).indexOf(currentSlide);

        const withWidth = (src, width) => {
            if (!src || !width) return src;
            const joiner = src.includes('?') ? '&' : '?';
            return `${src}${joiner}width=${width}`;
        };

        const getZoomWidth = (media) => {
            const w = media?.preview_image?.width;
            if (!w) return 2400;
            return Math.min(Math.max(w, 1600), 3000);
        };

        let zoomSlider = '';
        window.productMedia.forEach(i => {
            if (i.media_type == "external_video") {
                zoomSlider += `<div class="swiper-slide bg-white carousel-cell d-flex align-items-center justify-content-center zoom--product-image" data-mediaID="${i.id}" role="treeitem">
                  <div class="custom-video-container">
                      <custom-video class="placement--grid" data-video-type="${i.host}" data-video-id="${i.external_id}" data-placement="grid" data-autoplay="true" data-controls="true">
                          <div class="cta-btn" data-aos="hero">
                              <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                  <span class="icon-play text-body"></span>
                              </button>
                              <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                  <span class="icon-pause"></span>
                              </button>
                          </div>
                          <div class="content-section">
                              <div class="poster-image">
                                  <img class="img-fluid"
                                  src="${withWidth(i.preview_image.src, getZoomWidth(i))}"
                                  alt="${i.alt}"
                                  decoding="async"
                                  />
                              </div>
                          </div>
                          <div class="video-section" tabindex="0"></div>
                      </custom-video>
                  </div>
              </div>`;
            } else if (i.media_type == "video") {
                zoomSlider += `<div class="swiper-slide bg-white carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                  <div class="custom-video-container">
                      <custom-video class="placement--grid" data-video-type="local" data-video-id="${i.sources[0].url}" data-placement="grid" data-autoplay="true" data-controls="true">
                          <div class="cta-btn">
                              <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                  <span class="icon-play text-body"></span>
                              </button>
                              <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                  <span class="icon-pause"></span>
                              </button>
                          </div>
                          <div class="content-section">
                              <div class="poster-image">
                                  <img class="img-fluid"
                                  src="${withWidth(i.preview_image.src, getZoomWidth(i))}"
                                  alt="${i.alt}"/>
                              </div>
                          </div>
                          <div class="video-section" tabindex="0"></div>
                      </custom-video>
                  </div>
              </div>`;
            } else if (i.media_type == "image") {
                zoomSlider += `<div class="swiper-slide bg-white carousel-cell d-flex align-items-center justify-content-center zoom--product-image" data-mediaID="${i.id}" role="treeitem">
                  <img class="h-100 img-fluid object-fit-contain w-100"
                  src="${withWidth(i.preview_image.src, getZoomWidth(i))}"
                  alt="${i.alt}"
                  width="${i.preview_image.width}"
                  height="${i.preview_image.height}"
                  loading="lazy"
                  decoding="async"
                  />
              </div>`;
            }
        });
        let finalHTML = `<slider-element class="swiper-container zoom-slider position-relative carousel w-100">
          <div class="swiper swiper-slider zoom--product-images"
              data-slider='{
                      "loop": false,
                      "effect": "fade",
                      "observer": true,
                      "observeParents": true,
                      "slidesPerView": "1",
                      "spaceBetween": 15,
                      "grabCursor": true,
                      "navigation": {
                          "nextEl": ".zoom-next",
                          "prevEl": ".zoom-prev"
                      }
                  }' role="tree">
              <div class="swiper-wrapper" >${zoomSlider}</div>
          </div>
          <div class="swiper-button-prev zoom-prev start-0 ms-sm-4 ms-2" style="transform: rotate(90deg);">
            <svg width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.18945 0.896484C7.18945 0.626953 7.10742 0.410156 6.94336 0.246094C6.7793 0.0820313 6.5625 0 6.29297 0C6.02344 0 5.80664 0.0820313 5.64258 0.246094C5.47852 0.410156 5.39648 0.626953 5.39648 0.896484H7.18945ZM12.3223 12.3223C12.498 12.1465 12.5859 11.9385 12.5859 11.6982C12.5859 11.458 12.498 11.25 12.3223 11.0742C12.1465 10.8867 11.9385 10.793 11.6982 10.793C11.458 10.793 11.2441 10.8867 11.0566 11.0742L12.3223 12.3223ZM6.29297 17.1035L5.66016 17.7363C5.84766 17.9121 6.05859 18 6.29297 18C6.52734 18 6.73828 17.9121 6.92578 17.7363L6.29297 17.1035ZM1.5293 11.0742C1.3418 10.8867 1.12793 10.793 0.887695 10.793C0.647461 10.793 0.439453 10.8867 0.263672 11.0742C0.0878906 11.25 0 11.458 0 11.6982C0 11.9385 0.0878906 12.1465 0.263672 12.3223L1.5293 11.0742ZM5.39648 0.896484V17.1035H7.18945V0.896484H5.39648ZM11.0566 11.0742L5.66016 16.4707L6.92578 17.7363L12.3223 12.3223L11.0566 11.0742ZM6.92578 16.4707L1.5293 11.0742L0.263672 12.3223L5.66016 17.7363L6.92578 16.4707Z" fill="#283D39"/>
            </svg>
          </div>
          <div class="swiper-button-next zoom-next end-0 me-sm-4 me-2" style="transform: rotate(-90deg);">
            <svg width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.18945 0.896484C7.18945 0.626953 7.10742 0.410156 6.94336 0.246094C6.7793 0.0820313 6.5625 0 6.29297 0C6.02344 0 5.80664 0.0820313 5.64258 0.246094C5.47852 0.410156 5.39648 0.626953 5.39648 0.896484H7.18945ZM12.3223 12.3223C12.498 12.1465 12.5859 11.9385 12.5859 11.6982C12.5859 11.458 12.498 11.25 12.3223 11.0742C12.1465 10.8867 11.9385 10.793 11.6982 10.793C11.458 10.793 11.2441 10.8867 11.0566 11.0742L12.3223 12.3223ZM6.29297 17.1035L5.66016 17.7363C5.84766 17.9121 6.05859 18 6.29297 18C6.52734 18 6.73828 17.9121 6.92578 17.7363L6.29297 17.1035ZM1.5293 11.0742C1.3418 10.8867 1.12793 10.793 0.887695 10.793C0.647461 10.793 0.439453 10.8867 0.263672 11.0742C0.0878906 11.25 0 11.458 0 11.6982C0 11.9385 0.0878906 12.1465 0.263672 12.3223L1.5293 11.0742ZM5.39648 0.896484V17.1035H7.18945V0.896484H5.39648ZM11.0566 11.0742L5.66016 16.4707L6.92578 17.7363L12.3223 12.3223L11.0566 11.0742ZM6.92578 16.4707L1.5293 11.0742L0.263672 12.3223L5.66016 17.7363L6.92578 16.4707Z" fill="#283D39"/>
            </svg>
          </div>
          <zoom-feature>
          <div class="bottom-0 d-flex end-0 flex-column position-fixed z-index-1 zoom-controls mb-sm-4 mb-2 me-2 me-sm-4" style="gap:5px;">
                <button class="zoom-plus zoom_btn p-1 text-body my-auto transition modal__close-button bg-primary-100 d-flex align-items-center justify-content-center rounded-circle">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.75 6.75H12.75M6.75 12.75V0.75" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
                <button class="zoom-minus zoom_btn p-1 text-body my-auto transition modal__close-button bg-primary-100 d-flex align-items-center justify-content-center rounded-circle disabled">
                    <svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                         <path d="M0 0H14V2H0V0Z" fill="currentColor"/>
                    </svg>
                </button>
          </div>
          </zoom-feature>
      </slider-element>`;

        const zoomContainer = document.getElementById('PopupModal-zoom');
        if (zoomContainer) {
            zoomContainer.querySelector('.modal-body').innerHTML = finalHTML;
            zoomContainer.show();
            if (productZoomSlider) productZoomSlider.slideTo(currentSlideIndex, 2000, true);
        }
    }
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();



class ZoomFeature extends HTMLElement {
    constructor() {
        super();
        this.zoomRatio = 1; // Default zoom ratio
        this.maxZoomRatio = 4; // Maximum allowed zoom ratio
        this.isDragging = false; // Track dragging state
        this.isPinching = false; // Track pinch state
        this.activePointerId = null;
        this.startX = 0; // Starting X position for touch
        this.startY = 0; // Starting Y position for touch
        this.translateX = 0; // Current X translation
        this.translateY = 0; // Current Y translation
        this.initialPinchDistance = 0; // Initial pinch distance
        this.lastPinchZoom = 1; // Last pinch zoom ratio
        this.activeImage = null; // Reference to the currently zoomed image
        this.setupZoomControls();
    }

    setupZoomControls() {
        const zoomPlusBtns = this.querySelectorAll('.zoom-plus');
        const zoomMinusBtns = this.querySelectorAll('.zoom-minus');

        zoomPlusBtns.forEach((btn) => {
            btn.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                
                if (this.zoomRatio < this.maxZoomRatio) {
                    this.zoomRatio += 1;
                    if (this.zoomRatio >= this.maxZoomRatio) this.disableButton(btn);
                }
                this.updateZoom()
            });
        });
        
        zoomMinusBtns.forEach((btn) => {
            btn.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                if (this.zoomRatio > 1) {
                    this.zoomRatio -= 1;
                    if (this.zoomRatio < this.maxZoomRatio) this.enableButton(document.querySelector('.zoom-plus'));
                }
                this.updateZoom();
                
            });
        });
        setTimeout(() => {
            this.enableZoomOnTouch();
        }, 1000);
    }

    enableZoomOnTouch() {
        const images = document.querySelectorAll('#PopupModal-zoom .swiper-slide img');
        images.forEach((image) => {
            // Touch events for mobile
            image.addEventListener('touchstart', (event) => this.onTouchStart(event));
            image.addEventListener('touchmove', (event) => this.onTouchMove(event));
            image.addEventListener('touchend', (event) => this.onTouchEnd(event));

            // Pointer events for desktop panning (mouse + trackpad pointer).
            image.addEventListener('pointerdown', (event) => this.onPointerDown(event));
            image.addEventListener('pointermove', (event) => this.onPointerMove(event));
            image.addEventListener('pointerup', (event) => this.onPointerUp(event));
            image.addEventListener('pointercancel', (event) => this.onPointerUp(event));
        });
    }

    getZoomSliderElement() {
        return document.querySelector('#PopupModal-zoom .zoom-slider');
    }

    setSliderInteractivity(enabled) {
        const sliderElement = this.getZoomSliderElement();
        if (!sliderElement) return;

        if (typeof sliderElement.allowTouchMove === 'function') {
            sliderElement.allowTouchMove(enabled);
        }

        const swiper = typeof sliderElement.getSwiper === 'function' ? sliderElement.getSwiper() : sliderElement.slider;
        if (swiper?.mousewheel) {
            try {
                enabled ? swiper.mousewheel.enable() : swiper.mousewheel.disable();
            } catch (e) {}
        }
    }
    

    onTouchStart(event) {
        event.stopImmediatePropagation();
        if (event.touches.length === 2) {
            // Start pinch gesture
            this.isPinching = true;
            this.initialPinchDistance = this.calculatePinchDistance(event.touches);
            this.lastPinchZoom = this.zoomRatio;
        } else if (event.touches.length === 1 && this.zoomRatio > 1) {
            // Start drag gesture
            this.isDragging = true;
            this.startX = event.touches[0].clientX - this.translateX;
            this.startY = event.touches[0].clientY - this.translateY;
        }
        if (this.zoomRatio > 1) {
            this.setSliderInteractivity(false);
        }

        // document.body?.classList.add('overflow-hidden', 'touch-action-none');
    }

    onTouchMove(event) {
        event.stopImmediatePropagation();
        if (this.isPinching && event.touches.length === 2) {
            const currentPinchDistance = this.calculatePinchDistance(event.touches);
            const pinchZoomFactor = currentPinchDistance / this.initialPinchDistance;
            this.zoomRatio = Math.min(
                Math.max(this.lastPinchZoom * pinchZoomFactor, 1),
                this.maxZoomRatio
            );
            this.updateZoom();
        } else if (this.isDragging && event.touches.length === 1) {
            const touch = event.touches[0];
            this.translateX = touch.clientX - this.startX;
            this.translateY = touch.clientY - this.startY;

            const maxTranslateX = ((this.zoomRatio - 1) * this.activeImage?.offsetWidth || 0) / 2;
            const maxTranslateY = ((this.zoomRatio - 1) * this.activeImage?.offsetHeight || 0) / 2;

            this.translateX = Math.max(Math.min(this.translateX, maxTranslateX), -maxTranslateX);
            this.translateY = Math.max(Math.min(this.translateY, maxTranslateY), -maxTranslateY);

            this.activeImage.style.transform = `scale(${this.zoomRatio}) translate3d(${this.translateX}px, ${this.translateY}px, 0px)`;
            this.activeImage.style.transition = 'none';
        }
        if (this.zoomRatio > 1) {
            this.setSliderInteractivity(false);
        }
    }

    onTouchEnd(event) {
        event.stopImmediatePropagation();
        if (event.touches.length < 2) {
            this.isPinching = false;
        }
        if (event.touches.length === 0) {
            this.isDragging = false;
        }
        if (this.zoomRatio < 2) {
            document.querySelector('zoom-feature')?.resetTransform();
            this.setSliderInteractivity(true);
        }
    }

    onPointerDown(event) {
        if (event.pointerType === 'touch') return;
        if (event.button !== 0) return; // primary button only
        if (this.zoomRatio <= 1) return;

        const img = event.currentTarget;
        this.activeImage = img;

        this.isDragging = true;
        this.activePointerId = event.pointerId;

        try {
            img.setPointerCapture(event.pointerId);
        } catch (e) {}

        event.preventDefault();
        event.stopImmediatePropagation();

        this.startX = event.clientX - this.translateX;
        this.startY = event.clientY - this.translateY;
        this.setSliderInteractivity(false);

        img.style.cursor = 'grabbing';
    }

    onPointerMove(event) {
        if (!this.isDragging) return;
        if (this.activePointerId !== event.pointerId) return;
        if (this.zoomRatio <= 1 || !this.activeImage) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        this.translateX = event.clientX - this.startX;
        this.translateY = event.clientY - this.startY;

        const maxTranslateX = ((this.zoomRatio - 1) * (this.activeImage?.offsetWidth || 0)) / 2;
        const maxTranslateY = ((this.zoomRatio - 1) * (this.activeImage?.offsetHeight || 0)) / 2;

        this.translateX = Math.max(Math.min(this.translateX, maxTranslateX), -maxTranslateX);
        this.translateY = Math.max(Math.min(this.translateY, maxTranslateY), -maxTranslateY);

        this.activeImage.style.transform = `translate3d(${this.translateX}px, ${this.translateY}px, 0px) scale(${this.zoomRatio})`;
        this.activeImage.style.transition = 'none';
    }

    onPointerUp(event) {
        if (this.activePointerId !== event.pointerId) return;
        event.preventDefault();
        event.stopImmediatePropagation();

        this.isDragging = false;
        this.activePointerId = null;

        if (this.activeImage) {
            this.activeImage.style.cursor = this.zoomRatio > 1 ? 'grab' : '';
        }

        if (this.zoomRatio < 2) {
            this.resetTransform();
            this.setSliderInteractivity(true);
        }
    }

    calculatePinchDistance(touches) {
        const [touch1, touch2] = touches;
        const dx = touch2.clientX - touch1.clientX;
        const dy = touch2.clientY - touch1.clientY;
        return Math.sqrt(dx * dx + dy * dy);
    }

    updateZoom() {
        const activeImage = document.querySelector('#PopupModal-zoom .swiper-slide-active img');
        if (activeImage) {
            this.activeImage = activeImage;
            this.activeImage.style.transform = `translate3d(${this.translateX}px, ${this.translateY}px, 0px) scale(${this.zoomRatio})`;
            this.activeImage.style.transformOrigin = 'center center';
            this.activeImage.style.transition = 'transform 0.3s ease';
            this.activeImage.style.cursor = this.zoomRatio > 1 ? 'grab' : '';

            this.setSliderInteractivity(this.zoomRatio <= 1);

            // Update zoom buttons based on current zoom ratio
            const zoomPlusBtn = document.querySelector('.zoom-plus');
            const zoomMinusBtn = document.querySelector('.zoom-minus');

            if (this.zoomRatio >= this.maxZoomRatio) {
                this.disableButton(zoomPlusBtn);
            } else {
                this.enableButton(zoomPlusBtn);
            }

            if (this.zoomRatio <= 1) {
                this.disableButton(zoomMinusBtn);
            } else {
                this.enableButton(zoomMinusBtn);
            }
        }
    }

    resetTransform() {
        this.activeImage = this.activeImage || document.querySelector('#PopupModal-zoom .swiper-slide-active img');
        if (this.activeImage) {
            this.translateX = 0;
            this.translateY = 0;
            this.zoomRatio = 1;
            this.activeImage.style.transform = `translate3d(0px, 0px, 0px) scale(1)`;
            this.activeImage.style.cursor = '';
            this.setSliderInteractivity(true);

            const zoomPlusBtn = this.querySelector('.zoom-plus');
            const zoomMinusBtn = this.querySelector('.zoom-minus');
            this.enableButton(zoomPlusBtn);
            this.disableButton(zoomMinusBtn);
        }
    }

    disableButton(button) {
        if (button) {
            button.disabled = true;
            button.classList.add('disabled');
        }
    }

    enableButton(button) {
        if (button) {
            button.disabled = false;
            button.classList.remove('disabled');
        }
    }
}

customElements.define('zoom-feature', ZoomFeature);

// Video Reviews (PDP) interactions: overlay play, pause others
(() => {
    if (window.__viiaVideoReviewsBound) return;
    window.__viiaVideoReviewsBound = true;

    async function toggleVideoPlayback(video, card) {
    if (!video || !card) return;

    const allVideos = document.querySelectorAll('[data-video-review-video]');
    const allCards = document.querySelectorAll('.video-reviews__card');

    // stop all other videos
    allVideos.forEach((item) => {
        if (item !== video) {
            try {
                item.pause();
                item.controls = false;
            } catch (e) {}
        }
    });

    allCards.forEach((item) => {
        if (item !== card) {
            item.classList.remove('is-playing');
        }
    });

    // if current video already playing -> stop it
    if (!video.paused && !video.ended) {
        try {
            video.pause();
            video.controls = false;
        } catch (e) {}

        card.classList.remove('is-playing');
        return;
    }

    if (video.readyState === 0) {
        try {
            video.load();
        } catch (e) {}
    }

    video.playsInline = true;
    video.controls = true;
    card.classList.add('is-playing');

    try {
        video.muted = false;
        await video.play();
    } catch (e) {
        try {
            video.muted = true;
            await video.play();

            video.addEventListener(
                'playing',
                () => {
                    video.muted = false;
                },
                { once: true }
            );
        } catch (e2) {
            card.classList.remove('is-playing');
            video.controls = false;
        }
    }
}

    document.addEventListener('click', async (event) => {
        const btn = event.target.closest('[data-video-review-play]');
        if (!btn) return;

        event.preventDefault();
        event.stopPropagation();

        const card = btn.closest('.video-reviews__card');
        const video = card?.querySelector('[data-video-review-video]');

        // On mobile, don't allow "click to stop" via our custom UI.
        // Starting playback via the overlay is fine, stopping should be via native controls.
        if (video && window.matchMedia?.('(max-width: 767px)').matches && !video.paused && !video.ended) return;

        await toggleVideoPlayback(video, card);
    });

    // Allow click on the video itself to pause/resume too
    document.addEventListener('click', async (event) => {
        const video = event.target.closest?.('[data-video-review-video]');
        if (!video) return;

        // On mobile/touch, let the native player handle taps (no custom pause/reset).
        if (window.matchMedia?.('(max-width: 767px)').matches || 'ontouchstart' in window) return;

        const card = video.closest('.video-reviews__card');
        if (!card) return;

        if (event.target.closest('button, input, select, a')) return;

        event.preventDefault();
        event.stopPropagation();

        await toggleVideoPlayback(video, card);
    });

    const onStop = (event) => {
        const video = event.target;

        if (!(video instanceof HTMLVideoElement)) return;
        if (!video.matches('[data-video-review-video]')) return;

        const card = video.closest('.video-reviews__card');

        card?.classList.remove('is-playing');
        video.removeAttribute('controls');
    };

    document.addEventListener('pause', onStop, true);
    document.addEventListener('ended', onStop, true);
})();
